// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F5oTNh {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
}

.E2sF7v {
  flex: 1;
  overflow-y: auto;
}

.swQE01 {
  margin: 0 0 var(--spacing-2);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark, #1f1f1f);
}

.yPFDp4 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
  padding: var(--spacing-2, 16px);
  border: 1px solid var(--stroke-neutral-stronger, #666666);
  border-radius: var(--radius-s, 4px);
  background-color: var(--surface-neutral-pale, #fafafa);
}

.b2y1Zo {
  margin: 0;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-lg, 16px);
  font-weight: var(--font-weight-semibold, 600);
  line-height: var(--line-height-100);
  color: var(--text-neutral-dark, #1f1f1f);
}

.T8hdyK {
  display: flex;
  gap: var(--spacing-2);
  padding-top: var(--spacing-2);
}

.T8hdyK button {
  flex: 1;
}

.h7UbZA {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DrawerOperator/pages/EditOperator/EditOperator.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,+BAA+B;EAC/B,yDAAyD;EACzD,mCAAmC;EACnC,sDAAsD;AACxD;;AAEA;EACE,SAAS;EACT,iEAAiE;EACjE,oCAAoC;EACpC,6CAA6C;EAC7C,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".container {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  flex-direction: column;\n}\n\n.content {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.description {\n  margin: 0 0 var(--spacing-2);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n  padding: var(--spacing-2, 16px);\n  border: 1px solid var(--stroke-neutral-stronger, #666666);\n  border-radius: var(--radius-s, 4px);\n  background-color: var(--surface-neutral-pale, #fafafa);\n}\n\n.cardTitle {\n  margin: 0;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-lg, 16px);\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: var(--line-height-100);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.footer {\n  display: flex;\n  gap: var(--spacing-2);\n  padding-top: var(--spacing-2);\n}\n\n.footer button {\n  flex: 1;\n}\n\n.loading {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `F5oTNh`,
	"content": `E2sF7v`,
	"description": `swQE01`,
	"card": `yPFDp4`,
	"cardTitle": `b2y1Zo`,
	"footer": `T8hdyK`,
	"loading": `h7UbZA`
};
module.exports = ___CSS_LOADER_EXPORT___;
